import { useState, useEffect } from "react";
import Toaster from "./common/Toaster";
import { useSelector } from "react-redux";
import { GET_DOOR_INSPECTION_AUDIT_TRAIL, LINK_QR_CODES } from "../api/apiPath";
import http from "../api/server";

export default function QrAuditTrail({
  QRrRefNumber,
  propertyId,
  inspectionRefNumber,
}) {
  // const { doorRefNumber } = useParams();
  // const [hideSidebar, setHideSidebar] = useState(true);
  const { userObj } = useSelector((state) => state.user);

  const [groups, setGroups] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});
  const [loading, setLoading] = useState(false);
  const [doorRefNumber, setDoorRefNumber] = useState([]);

  const [summaries, setSummaries] = useState([]);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastType: "",
      toastString: "",
    });
  };

  const getIcon = (eventType) => {
    switch (eventType) {
      case "Door Inspected":
        return "fa-solid fa-magnifying-glass";
      case "Request for Change":
        return "fa-solid fa-clipboard-check";
      case "Rejected":
        return "fa-solid fa-xmark";
      case "Approved":
        return "fa-solid fa-check";
      default:
        return "fa-solid fa-circle-info";
    }
  };

  useEffect(() => {
    const fetchAuditTrail = async () => {
      try {
        setLoading(true);

        const linkParams = {
          PropertyId: propertyId,
          InspectionRefNo: inspectionRefNumber,
          QRCodeRefNo: QRrRefNumber, // scanned ref
          loggedinUserId: userObj?.userId || 0,
        };

        const linkResponse = await http.put(LINK_QR_CODES, null, {
          params: linkParams,
        });

        setDoorRefNumber(linkResponse?.data?.doorRefNo);

        const { data } = await http.get(GET_DOOR_INSPECTION_AUDIT_TRAIL, {
          params: { DoorReferenceNumber: linkResponse?.data?.doorRefNo },
        });
        setSummaries(data?.summaries || []);

        const grouped = {};

        data?.events?.forEach((item) => {
          if (!grouped[item.inspectionReferenceNumber]) {
            grouped[item.inspectionReferenceNumber] = [];
          }

          grouped[item.inspectionReferenceNumber].push({
            icon: getIcon(item.eventType),
            title: item.eventType,
            date: item.eventDate,
            boxText: item.performedBy
              ? `${item.eventType} by - ${item.performedBy}`
              : item.eventType,
          });
        });

        setGroups(grouped);
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          "An unexpected error occurred while fetching audit trail.";
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: message,
        });
      } finally {
        setLoading(false);
      }
    };

    if (userObj?.userId && propertyId && inspectionRefNumber && QRrRefNumber) {
      fetchAuditTrail();
    }
  }, [userObj?.userId, propertyId, inspectionRefNumber, QRrRefNumber]);

  const toggleGroup = (refNo) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [refNo]: !prev[refNo],
    }));
  };

  const groupKeys = Object.keys(groups);

  return (
    <>
      {userObj && (
        <div>
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={closeButton}
          />

          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
            <div className="booking-history-container w-100 mt-4">
              <div className="detail-grid mt-3 mb-4">
                <div>
                  <strong>Door Ref.No :</strong> {doorRefNumber}
                </div>

                <div>
                  <strong>Inspection Managed By :</strong>{" "}
                  {summaries?.[0]?.inspectionManagedBy ?? ""}
                </div>

                <div>
                  <strong>Property Name :</strong>{" "}
                  {summaries?.[0]?.propertyName ?? ""}
                </div>
              </div>

              {loading ? (
                <p>Loading timeline...</p>
              ) : (
                groupKeys.map((refNo, index) => {
                  const summary = summaries[index] || {
                    totalCriticalIssues: 0,
                    totalNonCompliantIssues: 0,
                  };

                  return (
                    <div
                      key={index}
                      className="floating-card mb-3"
                      style={{
                        background: "#fff",
                        borderRadius: "8px",
                        padding: "20px",
                        boxShadow: "0px 4px 12px rgba(0,0,0,0.10)",
                        cursor: "pointer",
                      }}
                      onClick={() => toggleGroup(refNo)}
                    >
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <h6 className="mb-0 text-start">
                          Inspection Reference Number: {refNo}
                          <br />
                          Total Critical Issues: {summary.totalCriticalIssues}
                          <br />
                          Total NonCompliant Issues:{" "}
                          {summary.totalNonCompliantIssues}
                        </h6>

                        <span style={{ fontSize: "22px" }}>
                          {expandedGroups[refNo] ? "▲" : "▼"}
                        </span>
                      </div>

                      <div
                        style={{
                          maxHeight: expandedGroups[refNo] ? "500px" : "0px",
                          overflow: "hidden",
                          transition: "max-height 0.4s ease",
                        }}
                      >
                        <hr className="mt-3" />

                        <div className="timeline mt-2">
                          {groups[refNo].map((step, idx) => (
                            <div className="timeline-item-row" key={idx}>
                              <div className="timeline-left">
                                <div className="timeline-icon">
                                  <i className={step.icon}></i>
                                </div>
                                <div
                                  className="timeline-info"
                                  style={{ textAlign: "left" }}
                                >
                                  <div className="inspection-title-after">
                                    {step.title}
                                  </div>
                                  <div className="inspection-date">
                                    {step.date}
                                  </div>
                                </div>
                              </div>

                              <div
                                className="inspection-box"
                                style={{ backgroundColor: "#e9ecef" }}
                              >
                                <span>{step.boxText}</span>
                                <span className="dropdown-arrow">▼</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
